import * as React from 'react';
import { Component } from 'react';
import { Konkurrence } from '../../models/Konkurrence';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import SkrivebordAdministrator from './SkrivebordAdministrator';
import SkrivebordLaerer from './SkrivebordLaerer';
import SkrivebordElev from './SkrivebordElev';
import SkrivebordEkstern from './SkrivebordEkstern';

interface SkrivebordContainerProps {
}

interface SkrivebordContainerState {
    konkurrencer: Konkurrence[];
    isLoading: boolean;
}

class SkrivebordContainer extends Component<SkrivebordContainerProps, SkrivebordContainerState> {
    constructor(props: SkrivebordContainerProps) {
        super(props);

        this.state = { konkurrencer: [], isLoading: true };
    }   

    render() {
        var bruger = getLoggedInBruger();

        switch (bruger.rolle) {
            case BrugerRolleEnum.Administrator:
                return <SkrivebordAdministrator />;
            case BrugerRolleEnum.Laerer:
                return <SkrivebordLaerer />;
            case BrugerRolleEnum.Elev:
                return <SkrivebordElev />;
            case BrugerRolleEnum.Ekstern:
                return <SkrivebordEkstern />;
            default:
                return <div><h1>Brugerrolle findes ikke: {bruger.rolle}</h1></div>;
        }
    }
}

export default SkrivebordContainer;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/SkrivebordContainer.tsx